import { Component, OnInit, Inject,ViewChild,ElementRef } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

import html2canvas from 'html2canvas';
// declare let html2canvas: any;
declare var $: any;
@Component({
  selector: 'app-ipd-modal',
  templateUrl: './ipd-modal.component.html',
  styleUrls: ['./ipd-modal.component.css']
})
export class IpdModalComponent implements OnInit {
    @ViewChild('screen') screen: ElementRef;
    @ViewChild('canvas') canvas: ElementRef;
    @ViewChild('downloadLink') downloadLink: ElementRef;

    placements = ['left'];
    popoverTitle = 'Are you sure?';
    popoverMessage = 'Are you really <b>sure</b> you want to do this?';
    confirmText = 'Yes <i class="fas fa-check"></i>';
    cancelText = 'No <i class="fas fa-times"></i>';
    confirmClicked = false;
    cancelClicked = false;fileDeleting:boolean = false;
    IpdForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;uploading:boolean=false;disabledInput:boolean=false;InsuranceFields:boolean=false;
    allUploads=[];alluploaded_Insurancedocs=[];s3url='';doc_type:string='';bds=[];treatments=[];doctors=[];hospitals=[];myrole:string='';IpdChk:boolean=false;
    isCashHidden:boolean=true;billedError:boolean=false;CalbilledAmt:number=0;isInsuranceHidden:boolean=true;insuranceError:boolean=false;patientpaidError:boolean=false;
    fileExits:boolean=false;bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];invalidName:boolean=false;invalidTreatment:boolean=false;invalidBd:boolean=false;
    dialogData:any;ShareData=[];CMAccess:any;UserId:any;
    cabStatus:any=0;disableArrivalPastDate:any;todayDate:Date = new Date();editCabStatus:boolean=false;consumable_lists_arr=[];rental_lists_arr=[];consumable_copy=[];rental_copy=[];
    constructor(public dialogRef: MatDialogRef<IpdModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
    private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder)
    {
        // for disable past date in arrival date-time//
       
        this.dialogData=data;
        this.IpdForm = this.formBuilder.group({
            'patient_name' : [null, Validators.required],
            'mobile' : [null, Validators.required],
            'patient_age' : [null,Validators.required],
            'gender' : [null,Validators.required],
            'doctor_id' : [null, Validators.required],
            'hospital_id' : [null, Validators.required],
            'treatment_id' : [null, Validators.required],
            'user_id' : [null, Validators.required],
            'room' : [null, Validators.required],
            'payment_mode' : [null, Validators.required],
            'surgery_date' : [null, Validators.required],
            'arrival_time' : [null,Validators.required],
            'treatment_time' : [null,Validators.required],
            'test' : [null,Validators.required],
            'attendant' : [null,Validators.required],
            'attendant_mobile' : [null,Validators.required],
            'admission_amt' : [0],
            'discharge_amt' : [0],
            'billed_amt' : [0, Validators.required],
            'settled_amt' : [0],
            'doctor_share' : [null],
            'hospital_share' : [null],
            'glamyo_share' : [null],
            'status': [0, Validators.required],
            'aadhar': [null, Validators.required],
            'copay_amt' : [0],
            'mou_amount' : [0],
            'non_consuamble_amt' : [0],
            'prop_mou_amt' : [0],
            'insurance_amt' : [0],
            'patient_due_amt' : [0],
            'paitent_paid_amt' : [0],
            'actual_doctorShare' : [null],
            'actual_hospitalShare' : [null],
            'approved_status': [null],
            'comments': [null],
            'is_specialCase':[null],
            'pickup_point' : [null],
            'pickup_date' : [null],
            'pickup_time' : [null],
            'return_cab':[null],
            'cab_reschedule':[this.editCabStatus],
            'lmcCount' : [],
            'circle_id' :[null],
            'emivendor' : [''],
            'surgery_change_reason' : [''],
            'load_approved_amt':[''],
            'sub_variation_amt':[''],
            'downpayment_amt':[''],
            'monthly_income':[''],
            'bank_balance':[''],
            'cancel_postpone_reason':[''],
            'cancel_postpone_reason_type':[],
            'lens_type' : [],
            'lens_price' : [],
            'rental_requirement':[null,Validators.required],
            'consumable_requirement':[null,Validators.required],
            'consumable_resources_ids':[null],
            'rental_resources_ids':[null]
        });
    }


    async GetConsumableResourcesData(){
        this.leadapi.getIpdResourcesList(1).subscribe((data:any) => {
        if(data.status)
        {
            this.consumable_lists_arr = data.data; 
            this.consumable_copy = this.consumable_lists_arr;
        }else{
            this.consumable_lists_arr = []; 
        }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async GetRentalResourcesData(){
        this.leadapi.getIpdResourcesList(4).subscribe((data:any) => {
        if(data.status)
        {
            this.rental_lists_arr = data.data;
            this.rental_copy = this.rental_lists_arr;
        }else{
            this.rental_lists_arr = [];
        }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    AddRemoveValidation(event){
        /* if(event.value==2 || event.value==19 || event.value==20 || event.value==21 || event.value==24 || event.value==52 || event.value==85 || event.value==39 || event.value==15 || event.value==16 || event.value==96){
            this.getTreatmentwiseDoc(this.IpdForm.controls['circle_id'].value,event.value,'');
        }else{
            this.getDoctor();
        } */
        // this.getTreatmentwiseDoc(this.IpdForm.controls['circle_id'].value,event.value,'');

        this.getDoctor();

        if(event.value==96 || event.value==159 || event.value==172 || event.value==170){
          this.IpdForm.controls['lmcCount'].setValidators(Validators.required);
        }else if(event.value==129){
            this.IpdForm.controls['lens_type'].setValidators(Validators.required);
            this.IpdForm.controls['lens_price'].setValidators(Validators.required);
        }else{
          this.IpdForm.controls['lmcCount'].setValidators(null);
          this.IpdForm.controls['lens_type'].setValidators(null);
          this.IpdForm.controls['lens_price'].setValidators(null);
        }
        this.IpdForm.controls['lmcCount'].updateValueAndValidity();
        this.IpdForm.controls['lens_type'].updateValueAndValidity();
        this.IpdForm.controls['lens_price'].updateValueAndValidity();
      }


    downloadImage(){
        html2canvas(this.screen.nativeElement).then(canvas => {
          this.canvas.nativeElement.src = canvas.toDataURL();
          this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
          this.downloadLink.nativeElement.download = 'GH-'+this.dialogData.lead_id+'.png';
          this.downloadLink.nativeElement.click();
        }

        );
      }

    ngOnInit(): void
    {
        this.getbds();this.getTreatment();
        this.getHospital();
        this.getIpdDetails();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.CMAccess = localStorage.getItem('CMAccess');
        this.UserId = localStorage.getItem('loginuserId');
        this.s3url = localStorage.getItem('s3url');
        if(this.myrole=='1' || (this.myrole=='3' && (this.UserId=='73' || this.UserId=='1'))){
            this.disableArrivalPastDate = false;
        }else{
            this.disableArrivalPastDate = new Date().toISOString().slice(0, 16);
        }
        this.GetConsumableResourcesData();
        this.GetRentalResourcesData();
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='consumables'){
            $("#consumableSearch").val('');
            $("#consumableSearch").focus();
            this.consumable_lists_arr= this.consumable_copy;
        }else if(type=='rentals'){
            $("#rentalSearch").val('');
            $("#rentalSearch").focus();
            this.rental_lists_arr= this.rental_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else if(type == 'consumables'){
            this.consumable_lists_arr = this.sharedapi.searchData(searchtText, this.consumable_copy, "name");
        }else if(type == 'rentals'){
            this.rental_lists_arr = this.sharedapi.searchData(searchtText, this.rental_copy, "name");
        }
    }

    selectAadhar(event)
    {
        const file = (event.target as HTMLInputElement).files[0];
        this.IpdForm.patchValue({
          aadhar: file
        });

    }

    setCancelPostponeValidator()
    {
        this.IpdForm.controls['cancel_postpone_reason'].setValue('');
        this.IpdForm.controls['cancel_postpone_reason_type'].setValue('');
        if(this.IpdForm.controls['status'].value=='3' || this.IpdForm.controls['status'].value=='4'){
            this.IpdForm.controls['cancel_postpone_reason'].setValidators(Validators.required);
            this.IpdForm.controls['cancel_postpone_reason_type'].setValidators(Validators.required);
        } else {
            this.IpdForm.controls['cancel_postpone_reason'].setValidators(null);
            this.IpdForm.controls['cancel_postpone_reason_type'].setValidators(null);
        }
        this.IpdForm.controls['cancel_postpone_reason'].updateValueAndValidity();
        this.IpdForm.controls['cancel_postpone_reason_type'].updateValueAndValidity();
    }

    addRemoveRentalValidator(event){
        if(event==1){
            this.IpdForm.controls['rental_resources_ids'].setValidators(null);
        }else{
            this.IpdForm.controls['rental_resources_ids'].setValidators(Validators.required);
        }
        this.IpdForm.controls['rental_resources_ids'].updateValueAndValidity();
    }

    addRemoveConsumablesValidator(event){
        if(event==1){
            this.IpdForm.controls['consumable_resources_ids'].setValidators(null);
        }else{
            this.IpdForm.controls['consumable_resources_ids'].setValidators(Validators.required);
        }
        this.IpdForm.controls['consumable_resources_ids'].updateValueAndValidity();
    }

    

    setpaymentType(){
        console.log(this.IpdForm.controls['payment_mode'].value);
        if(this.IpdForm.controls['payment_mode'].value=='1'){
            this.isCashHidden=true;
        }else{
            this.isCashHidden=false;
        }
        if(this.IpdForm.controls['payment_mode'].value==4){
            this.IpdForm.controls['emivendor'].setValidators(Validators.required);
            this.IpdForm.controls['load_approved_amt'].setValidators(Validators.required);
            this.IpdForm.controls['sub_variation_amt'].setValidators(Validators.required);
            this.IpdForm.controls['downpayment_amt'].setValidators(Validators.required);
            this.IpdForm.controls['monthly_income'].setValidators(Validators.required);
            this.IpdForm.controls['bank_balance'].setValidators(Validators.required);
        }else{
            this.IpdForm.controls['emivendor'].setValidators(null);
            this.IpdForm.controls['load_approved_amt'].setValidators(null);
            this.IpdForm.controls['sub_variation_amt'].setValidators(null);
            this.IpdForm.controls['downpayment_amt'].setValidators(null);
            this.IpdForm.controls['monthly_income'].setValidators(null);
            this.IpdForm.controls['bank_balance'].setValidators(null);
        }
            this.IpdForm.controls['emivendor'].updateValueAndValidity();
            this.IpdForm.controls['load_approved_amt'].updateValueAndValidity();
            this.IpdForm.controls['sub_variation_amt'].updateValueAndValidity();
            this.IpdForm.controls['downpayment_amt'].updateValueAndValidity();
            this.IpdForm.controls['monthly_income'].updateValueAndValidity();
            this.IpdForm.controls['bank_balance'].updateValueAndValidity();

    }

    calculatesettledAmt(type){

        let mou_amount=this.IpdForm.controls['mou_amount'].value;
        let getBillamt=this.IpdForm.controls['billed_amt'].value;
        let patient_due_amt=this.IpdForm.controls['patient_due_amt'].value;
        let billed_amt:any=0;
        billed_amt= parseInt(getBillamt) - parseInt(mou_amount);
        if(type=='1'){
            this.IpdForm.patchValue({
            'settled_amt': billed_amt
            });
        }if(type=='2'){
            let copay_amt=this.IpdForm.controls['copay_amt'].value;
            let non_consuamble_amt=this.IpdForm.controls['non_consuamble_amt'].value;
            let prop_mou_amt=this.IpdForm.controls['prop_mou_amt'].value;
            let paitent_paid_amt:any=0;
            if(this.IpdForm.controls['paitent_paid_amt'].value){
                paitent_paid_amt=this.IpdForm.controls['paitent_paid_amt'].value;
            }else{
                paitent_paid_amt=0;
            }
            let consumableTotal:any=0;
            consumableTotal = parseInt(copay_amt) + parseInt(non_consuamble_amt) + parseInt(prop_mou_amt);

            let settled_amt:any=0;
            settled_amt= parseInt(billed_amt) - parseInt(consumableTotal) + parseInt(paitent_paid_amt);
            this.IpdForm.patchValue({
                'settled_amt': settled_amt
            });

            if(paitent_paid_amt > patient_due_amt){
                this.patientpaidError=true;
            }else{
                this.patientpaidError=false;
            }

        }

    }

    calculateBilledAmt(){
        let admission_amt:any=0;
        let discharge_amt:any=0;
        let calculate_amt:any=0;
        if(this.IpdForm.controls['admission_amt'].value){
            admission_amt=this.IpdForm.controls['admission_amt'].value;
        }else{
            admission_amt=0;
        }
        if(this.IpdForm.controls['discharge_amt'].value){
            discharge_amt=this.IpdForm.controls['discharge_amt'].value;
        }else{
            discharge_amt=0;
        }

        if(this.IpdForm.controls['payment_mode'].value=='1'){
            calculate_amt = parseInt(admission_amt) + parseInt(discharge_amt);
        }
        this.CalbilledAmt=calculate_amt;
        this.IpdForm.patchValue({
            'billed_amt': this.CalbilledAmt,
            'settled_amt': this.CalbilledAmt
        });
    }

    calculateHiddenAmt(){
        let mou_amt:any=0;
        let billedAmt:any=0;
        let copay_amt:any=0;
        let non_consuamble_amt:any=0;
        let prop_mou_amt:any=0;
        let insurance_amt:any=0;
        let patient_due_amt:any=0;

        if(this.IpdForm.controls['copay_amt'].value){
            copay_amt=this.IpdForm.controls['copay_amt'].value;
        }else{
            copay_amt=0;
        }
        if(this.IpdForm.controls['non_consuamble_amt'].value){
            non_consuamble_amt=this.IpdForm.controls['non_consuamble_amt'].value;
        }else{
            non_consuamble_amt=0;
        }
        if(this.IpdForm.controls['prop_mou_amt'].value){
            prop_mou_amt=this.IpdForm.controls['prop_mou_amt'].value;
        }else{
            prop_mou_amt=0;
        }

        if(this.IpdForm.controls['mou_amount'].value){
            mou_amt=this.IpdForm.controls['mou_amount'].value;
        }else{
            mou_amt=0;
        }

        billedAmt= parseInt(this.IpdForm.controls['billed_amt'].value) - parseInt(mou_amt);

        patient_due_amt= parseInt(copay_amt) + parseInt(non_consuamble_amt) + parseInt(prop_mou_amt);
        insurance_amt= parseInt(billedAmt) - (parseInt(copay_amt) + parseInt(non_consuamble_amt) + parseInt(prop_mou_amt));

        let settled_amt:any=0;
        settled_amt= parseInt(billedAmt) - (parseInt(patient_due_amt) - parseInt(this.IpdForm.controls['paitent_paid_amt'].value));

        if(insurance_amt < 0){
            this.insuranceError=true;
        }else{
            this.insuranceError=false;
        }

        this.IpdForm.patchValue({
            'insurance_amt': insurance_amt,
            'patient_due_amt' :patient_due_amt,
            'settled_amt' : settled_amt
        });

    }

    checkInsuranceAmt(){
        let billed_amt=this.IpdForm.controls['billed_amt'].value;
        let copay_amt=this.IpdForm.controls['copay_amt'].value;
        let non_consuamble_amt=this.IpdForm.controls['non_consuamble_amt'].value;
        let prop_mou_amt=this.IpdForm.controls['prop_mou_amt'].value;
        let insurance_amt=this.IpdForm.controls['insurance_amt'].value;
        let consumableTotal:any=0;
        consumableTotal= parseInt(copay_amt) + parseInt(non_consuamble_amt) + parseInt(prop_mou_amt);
        let calculateTotal= parseInt(insurance_amt) + parseInt(consumableTotal);
        if(calculateTotal > billed_amt){
            this.insuranceError=true;
        }else{
            this.insuranceError=false;
        }

    }

    async updateIpd()
    {
        
        console.log(this.IpdForm.controls);
        if(this.fileExits){
            const AadharCard = this.IpdForm.get('aadhar');
            AadharCard.clearValidators();
            AadharCard.updateValueAndValidity();
        }

        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.IpdForm.invalid) {
            this.loading = false;
            return;
        }
        
        if(this.IpdForm.controls['payment_mode'].value=='1' && this.IpdForm.controls['billed_amt'].value==0){
           this.billedError=true;
           this.loading = false;
           return;
        }else{
            this.billedError=false;
        }

        if(this.IpdForm.controls['patient_name'].value.trim()=='NA' || this.IpdForm.controls['patient_name'].value.trim()=='N/A'){
            this.loading = false;
            this.invalidName= true;
            return;
        }else{
            this.invalidName= false;
        }

        if(this.IpdForm.controls['treatment_id'].value=='37' || this.IpdForm.controls['treatment_id'].value==37){
            this.loading = false;
            this.invalidTreatment= true;
            return;
        }else{
            this.invalidTreatment= false;
        }
        if(this.IpdForm.controls['user_id'].value=='21' || this.IpdForm.controls['user_id'].value==21){
            this.loading = false;
            this.invalidBd= true;
            return;
        }else{
            this.invalidBd= false;
        }

        if(this.insuranceError){
            this.loading = false;
            return;
        }

        await this.leadapi.updateIpd(this.data,this.IpdForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast(data.msg);
                this.getIpdDetails();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });


    }

    get f() { return this.IpdForm.controls; }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            let file = event.target.files.item(0);
            const formData = new FormData();
            formData.append('upload_type',this.doc_type)
            formData.append('file', file);
            await this.leadapi.uploadIpdFile(this.data,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.getIpdDetails();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error =>
                {
                    this.uploading = false;
                    this.sharedapi.checkError(error);
                });
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }

    async getTreatmentwiseDoc(circle_id,treatment_id,olddocId)
    {
        await this.leadapi.gettreatdoctors(circle_id,treatment_id,olddocId).subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getIpdDetails()
    {
        this.doc_type = '';
        this.dataLoaded = false;
        this.leadapi.getIpdDetails(this.data).subscribe(
        (data:any) => {
            this.dataLoaded = true;
            if(data.status)
            {
                if(data.lead)
                {
                    if(data.data.length == 0){
                        /* if((data.lead.circle_id==2 || data.lead.circle_id==3 || data.lead.circle_id==6) && (data.lead.treatment_id==2 || data.lead.treatment_id==19 || data.lead.treatment_id==20 || data.lead.treatment_id==21 || data.lead.treatment_id==24 || data.lead.treatment_id==52 || data.lead.treatment_id==85 || data.lead.treatment_id==39 || data.lead.treatment_id==15 || data.lead.treatment_id==16 || data.lead.treatment_id==96)){
                            this.getTreatmentwiseDoc(data.lead.circle_id,data.lead.treatment_id,'');
                        }else{
                            this.getDoctor();
                        } */
                        this.getDoctor();
                    }else{
                        this.getDoctor();
                    }

                    this.IpdForm.controls['patient_name'].setValue(data.lead.lead_name);
                    this.IpdForm.controls['mobile'].setValue(data.lead.mobile);
                    this.IpdForm.controls['treatment_id'].setValue(data.lead.treatment_id);
                    this.IpdForm.controls['user_id'].setValue(data.lead.user_id);
                    this.IpdForm.controls['payment_mode'].setValue(data.lead.payment_mode);
                    this.IpdForm.controls['room'].setValue(data.lead.insurance_room);
                    this.IpdForm.controls['patient_age'].setValue(data.lead.patient_age);
                    this.IpdForm.controls['gender'].setValue(data.lead.gender);
                    this.IpdForm.controls['circle_id'].setValue(data.lead.circle_id);

                    /********If IPD Arrival datetime is blank****************** */
                    if(data.data.length == 0){
                        this.IpdForm.controls['hospital_id'].setValue(data.lead.preauth_hospital_id);
                        this.IpdForm.controls['arrival_time'].setValue(data.lead.preauth_arrival_date_time);
                        this.IpdForm.controls['doctor_id'].setValue(data.lead.preauth_doctor_id);
                    }
                    /***********If IPD Arrival datetime is blank*************** */


                    if((data.lead.payment_mode==2 || data.lead.payment_mode==3 || !data.lead.payment_mode) && this.myrole!='1' && this.myrole!='5' && this.myrole!='4' && this.myrole!='9')
                    {
                        this.disabledInput = true;
                    }
                    if(data.lead.payment_mode && data.lead.payment_mode!=1){
                        this.isCashHidden=false;
                    }

                    if(this.IpdForm.controls['payment_mode'].value=='4'){
                        this.setpaymentType();
                    }

                    if(data.lead.treatment_id==96 || data.lead.treatment_id==159 || data.lead.treatment_id==172  || data.lead.treatment_id==170){
                        this.IpdForm.controls['lmcCount'].setValidators(Validators.required);
                    }
                    else if(data.lead.treatment_id==129){
                        this.IpdForm.controls['lens_type'].setValidators(Validators.required);
                        this.IpdForm.controls['lens_price'].setValidators(Validators.required);
                    }else{
                        this.IpdForm.controls['lmcCount'].setValidators(null);
                        this.IpdForm.controls['lens_type'].setValidators(null);
                        this.IpdForm.controls['lens_price'].setValidators(null);
                    }
                    this.IpdForm.controls['lmcCount'].updateValueAndValidity();
                    this.IpdForm.controls['lens_type'].updateValueAndValidity();
                    this.IpdForm.controls['lens_price'].updateValueAndValidity();

                }
                if(data.data)
                {
                    if(data.data.payment_mode==4)
                    {
                        this.setpaymentType();
                    }

                    /**********Validation For Cancel Postpone Reason************** */
                    if(data.data.status=='3' || data.data.status=='4'){
                        this.IpdForm.controls['cancel_postpone_reason'].setValidators(Validators.required);
                        this.IpdForm.controls['cancel_postpone_reason_type'].setValidators(Validators.required);
                    } else {
                        this.IpdForm.controls['cancel_postpone_reason'].setValidators(null);
                        this.IpdForm.controls['cancel_postpone_reason_type'].setValidators(null);
                    }
                    this.IpdForm.controls['cancel_postpone_reason'].updateValueAndValidity();
                    this.IpdForm.controls['cancel_postpone_reason_type'].updateValueAndValidity();
                    /**********Validation For Cancel Postpone Reason************** */


                    /*  if((data.lead.circle_id==2 || data.lead.circle_id==3 || data.lead.circle_id==6) && (data.lead.treatment_id==2 || data.lead.treatment_id==19 || data.lead.treatment_id==20 || data.lead.treatment_id==21 || data.lead.treatment_id==24 || data.lead.treatment_id==52 || data.lead.treatment_id==85 || data.lead.treatment_id==39 || data.lead.treatment_id==15 || data.lead.treatment_id==16 || data.lead.treatment_id==96)){
                        this.getTreatmentwiseDoc(data.lead.circle_id,data.lead.treatment_id,data.data.doctor_id);
                    }else{
                        this.getDoctor();
                    } */

                    this.getDoctor();

                    this.allUploads = data.uploads;
                    this.alluploaded_Insurancedocs = data.uploaded_Insurancedocs;
                    this.fileExits = this.allUploads.some(function(el){ return el.upload_type === 1});
                    this.IpdChk = true;
                    this.IpdForm.controls['patient_name'].setValue(data.data.patient);
                    this.IpdForm.controls['mobile'].setValue(data.data.phone);
                    this.IpdForm.controls['doctor_id'].setValue(data.data.doctor_id);
                    this.IpdForm.controls['hospital_id'].setValue(data.data.hospital_id);
                    this.IpdForm.controls['treatment_id'].setValue(data.data.treatment_id);
                    this.IpdForm.controls['user_id'].setValue(data.data.user_id);
                    this.IpdForm.controls['room'].setValue(data.data.room);
                    this.IpdForm.controls['payment_mode'].setValue(data.data.payment_mode);
                    this.IpdForm.controls['surgery_date'].setValue(new Date(data.data.surgery_date*1000));
                    this.IpdForm.controls['surgery_change_reason'].setValue(data.data.surgery_change_reason ? data.data.surgery_change_reason : '');
                    this.IpdForm.controls['arrival_time'].setValue(data.data.arrival_time);
                    this.IpdForm.controls['treatment_time'].setValue(data.data.treatment_time);
                    this.IpdForm.controls['status'].setValue(data.data.status);
                    this.IpdForm.controls['cancel_postpone_reason_type'].setValue(data.data.cancel_postpone_reason_type?data.data.cancel_postpone_reason_type:'');
                    this.IpdForm.controls['cancel_postpone_reason'].setValue(data.data.cancel_postpone_reason?data.data.cancel_postpone_reason:'');
                    this.IpdForm.controls['test'].setValue(data.data.test);
                    this.IpdForm.controls['attendant'].setValue(data.data.attendant);
                    this.IpdForm.controls['attendant_mobile'].setValue(data.data.attendant_mobile);
                    this.IpdForm.controls['admission_amt'].setValue(data.data.admission_amt);
                    this.IpdForm.controls['discharge_amt'].setValue(data.data.discharge_amt);
                    this.IpdForm.controls['billed_amt'].setValue(data.data.billed_amt);
                    this.IpdForm.controls['is_specialCase'].setValue(data.data.is_specialCase);
                    this.IpdForm.controls['pickup_point'].setValue(data.data.pickup_point);
                    let pickupDate = (data.data.pickup_date!=null)?new Date(data.data.pickup_date*1000):null;
                    this.IpdForm.controls['pickup_date'].setValue(pickupDate);
                    this.IpdForm.controls['pickup_time'].setValue(data.data.pickup_time);
                    this.IpdForm.controls['return_cab'].setValue((data.data.return_cab==1)?true:false);
                    this.cabStatus = data.data.cab_status;
                    this.IpdForm.controls['approved_status'].setValue(data.data.approved_status);
                    if(data.data.comments){
                        this.IpdForm.controls['comments'].setValue(data.data.comments);
                    }

                    this.IpdForm.controls['copay_amt'].setValue(data.data.copay_amt);
                    this.IpdForm.controls['non_consuamble_amt'].setValue(data.data.non_consuamble_amt);
                    if(!data.data.prop_mou_amt){
                        data.data.prop_mou_amt=0;
                    }
                    if(!data.data.mou_amt){
                        data.data.mou_amt=0;
                    }
                    if(!data.data.insurance_amt){
                        data.data.insurance_amt=0;
                    }
                    if(!data.data.paitent_paid_amt){
                        data.data.paitent_paid_amt=0;
                    }
                    this.IpdForm.controls['mou_amount'].setValue(data.data.mou_amt);
                    this.IpdForm.controls['prop_mou_amt'].setValue(data.data.prop_mou_amt);
                    this.IpdForm.controls['insurance_amt'].setValue(data.data.insurance_amt);
                    this.IpdForm.controls['paitent_paid_amt'].setValue(data.data.paitent_paid_amt);

                    var patient_due_amt:any=0;
                    patient_due_amt= parseInt(data.data.copay_amt) + parseInt(data.data.non_consuamble_amt) + parseInt(data.data.prop_mou_amt);
                    this.IpdForm.controls['patient_due_amt'].setValue(patient_due_amt);
                    this.IpdForm.controls['settled_amt'].setValue(data.data.settled_amt);
                    if(this.myrole=='1')
                    {
                        if(!data.data.doctor_share && !data.data.hospital_share){
                            this.getHospital_DoctorShare(data.data.treatment_id,data.data.doctor_id,data.data.hospital_id);
                        }else{
                            this.IpdForm.controls['doctor_share'].setValue(data.data.doctor_share);
                            this.IpdForm.controls['hospital_share'].setValue(data.data.hospital_share);
                            this.IpdForm.controls['glamyo_share'].setValue(data.data.glamyo_share);
                        }
                    }
                    if(data.data.payment_mode && data.data.payment_mode!=1){
                        this.isCashHidden=false;
                    }
                    this.IpdForm.controls['lmcCount'].setValue(data.data.lmcCount);
                    if(data.data.lmcCount==0){
                        this.IpdForm.controls['lmcCount'].setValue('');
                    }
                    this.IpdForm.controls['emivendor'].setValue(data.data.emi_vendor_name ? parseInt(data.data.emi_vendor_name):'');
                    this.IpdForm.controls['load_approved_amt'].setValue(data.data.load_approved_amt);
                    this.IpdForm.controls['sub_variation_amt'].setValue(data.data.sub_variation_amt);
                    this.IpdForm.controls['downpayment_amt'].setValue(data.data.downpayment_amt);
                    this.IpdForm.controls['monthly_income'].setValue(data.data.monthly_income);
                    this.IpdForm.controls['bank_balance'].setValue(data.data.bank_balance);
                    this.IpdForm.controls['lens_type'].setValue(data.data.lens_type);
                    this.IpdForm.controls['lens_price'].setValue(data.data.lens_price);
                    this.IpdForm.controls['rental_requirement'].setValue(data.data.rental_requirement);
                    this.IpdForm.controls['consumable_requirement'].setValue(data.data.consumable_requirement);
                    
                    if(data.data.rental_requirement == 2)
                    {
                        this.IpdForm.controls['rental_resources_ids'].setValue(data.data.rental_resources_ids);
                        this.addRemoveRentalValidator(2);
                    } else {
                        this.addRemoveRentalValidator(1);
                    }

                    if(data.data.consumable_requirement == 2)
                    {
                        this.IpdForm.controls['consumable_resources_ids'].patchValue(data.data.consumable_resources_ids);
                        this.addRemoveConsumablesValidator(2);
                    } else {
                        this.addRemoveConsumablesValidator(1);
                    }


                   
                }
               
            }else{
                if(data.error_type!='no')
                this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async getHospital_DoctorShare(treatmentId,doctorId,hospitalId)
    {
        let data={
          treatment_id:treatmentId,
          doctor_id:doctorId,
          hospital_id:hospitalId
        }
        this.leadapi.getHDShares(data).subscribe((data:any) => {
            if(data.status)
            {
              this.ShareData= data.data;
              this.IpdForm.controls['hospital_share'].setValue(this.ShareData[0].hospitalshare);
              this.IpdForm.controls['doctor_share'].setValue(this.ShareData[0].doctorshare);

              this.IpdForm.controls['actual_hospitalShare'].setValue(this.ShareData[0].hospitalshare);
              this.IpdForm.controls['actual_doctorShare'].setValue(this.ShareData[0].doctorshare);

              //this.calculate_glamyoShare();
            }else{
              this.ShareData=[];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    CloseModal(): void {
        this.dialogRef.close();
    }

    async getbds()
    {
        await this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctor()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getHospital()
    {
        this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    removeFile(fileId)
    {
        this.fileDeleting = true;
        this.leadapi.deleteIpdFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
                this.getIpdDetails();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    removeFileInsurance(fileId)
    {
        this.fileDeleting = true;
        this.leadapi.deleteInsuranceFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
                this.getIpdDetails();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    /**
     * Set pickup datetime validation based on pickup point..
     */
    pickupPointChange(event){
      let pickup_point = event.target.value.trim();
      if(pickup_point.length){
        this.IpdForm.controls['pickup_date'].setValidators(Validators.required);
        this.IpdForm.controls['pickup_time'].setValidators(Validators.required);
      } else {
        this.IpdForm.controls['pickup_date'].setValidators(null);
        this.IpdForm.controls['pickup_time'].setValidators(null);
        this.IpdForm.controls['pickup_date'].patchValue(null);
        this.IpdForm.controls['pickup_time'].patchValue(null);
      }
      this.IpdForm.controls['pickup_date'].updateValueAndValidity();
      this.IpdForm.controls['pickup_time'].updateValueAndValidity();
    }

    edit_cab_status(event){
      this.editCabStatus = event.target.checked;
    }

}
